'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./view.less');

var _next = require('@alifd/next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Tooltip = _next.Balloon.Tooltip;
// C端

// 每条150个字展示限制
var contentControl = 150;

var MessageField = (_temp = _class = function (_React$Component) {
  _inherits(MessageField, _React$Component);

  function MessageField(props) {
    _classCallCheck(this, MessageField);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      expand: true // 收起展开状态，默认展开
    };
    return _this;
  }

  // 单条内容展示


  MessageField.prototype.handleLine = function handleLine(str) {
    var result = str.trim();
    return result.length > contentControl ? _react2.default.createElement(
      Tooltip,
      { trigger: result.slice(0, contentControl) + '...', align: 'b' },
      result
    ) : result;
  };

  MessageField.prototype.showContent = function showContent(tipsContents, enableExpand) {
    var _this2 = this;

    var Tips = tipsContents.map(function (content) {
      return content ? _react2.default.createElement(
        'p',
        null,
        _this2.handleLine(content)
      ) : '';
    });
    if (enableExpand) {
      return this.state.expand ? Tips : null;
    }

    return Tips;
  };

  MessageField.prototype.showTitle = function showTitle(tipsTitle, enableExpand) {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      { className: 'message-title' },
      tipsTitle,
      enableExpand ? _react2.default.createElement(_next.Icon, {
        size: 'xs',
        type: this.state.expand ? 'arrow-up' : 'arrow-down',
        className: 'message-expand-icon ' + (enableExpand ? 'expand-icon--cursor' : ''),
        onClick: function onClick() {
          enableExpand && _this3.setState({ expand: !_this3.state.expand });
        }
      }) : null
    );
  };

  MessageField.prototype.render = function render() {
    var _props = this.props,
        fieldId = _props.fieldId,
        visible = _props.visible,
        tipsTitle = _props.tipsTitle,
        tipsContent1 = _props.tipsContent1,
        tipsContent2 = _props.tipsContent2,
        tipsContent3 = _props.tipsContent3,
        tipsContent4 = _props.tipsContent4,
        tipsContent5 = _props.tipsContent5,
        tipsContent6 = _props.tipsContent6,
        tipsContent7 = _props.tipsContent7,
        tipsContent8 = _props.tipsContent8,
        tipsContent9 = _props.tipsContent9,
        tipsContent10 = _props.tipsContent10,
        enableClose = _props.enableClose,
        enableExpand = _props.enableExpand,
        type = _props.type,
        $state = _props.$state,
        isInDetail = _props.isInDetail;


    var renderProps = {
      className: (0, _classnames2.default)('vc-message', { 'vc-form-item-hidden': !visible }),
      'data-field-id': fieldId
    };

    return !isInDetail ? _react2.default.createElement(
      _next.Message,
      _extends({}, renderProps, {
        title: this.showTitle(tipsTitle, enableExpand),
        type: type,
        closeable: enableClose,
        visible: true,
        onClose: function onClose() {
          $state.set('visible', false);
        }
      }),
      this.showContent([tipsContent1, tipsContent2, tipsContent3, tipsContent4, tipsContent5, tipsContent6, tipsContent7, tipsContent8, tipsContent9, tipsContent10], enableExpand)
    ) : '';
  };

  return MessageField;
}(_react2.default.Component), _class.displayName = 'Message', _class.defaultProps = { tipsTitle: '', tipsContent1: '', type: 'success' }, _temp);
exports.default = MessageField;
module.exports = exports['default'];